import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=84040458&"
import script from "./NewLogin.vue?vue&type=script&lang=js&"
export * from "./NewLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports